/*
 * @Author: your name
 * @Date: 2021-07-07 12:03:27
 * @LastEditTime: 2021-07-15 11:09:21
 * @LastEditors: lyy
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\router\jobUnitQuery.js
 */
const jobUnitQuery = [
  {
    path: '/job-unit-query-home', //测绘作业单位查询主页
    name: 'jobUnitQueryHome',
    component: () => import('../views/JobUnitQuery/JobUnitQueryHome.vue')
    // meta: {
    //   requiresAuth: true
    //   // title: '投票管理'   // 标题设置
    // }
  },
  {
    path: '/job-unit-query-list', //测绘作业单位查询列表
    name: 'jobUnitQueryList',
    component: () => import('../views/JobUnitQuery/JobUnitQueryList.vue')
  },
  {
    path: '/job-unit-query-detail', // 测绘作业单位查询详情
    name: 'jobUnitQueryDetail',
    component: () => import('../views/JobUnitQuery/JobUnitQueryDetail.vue')
    // meta: {
    //   requiresAuth: true
    // }
  }
]
// {
// path: '/jobUnitQuery',
// name: 'jobUnitQuery',
// component: () => import('../views/JobUnitQuery/index.vue'),
// meta: {
//   keepAlive: false,
//   requiresAuth: true
// },
// redirect: 'jobUnitQuery/index',
// children: [

// ]
// }

export default jobUnitQuery
